import { createContext, useCallback, useState } from 'react'

import { CollectionPageContents_collection, ContentPage } from 'globalTypes'

interface ContextProps {
  collection?: CollectionPageContents_collection
  nextElement?: ContentPage
  previousElement?: ContentPage
  updateCollectionData?: (data: {
    collection: CollectionPageContents_collection
    previousElement?: ContentPage
    nextElement?: ContentPage
  }) => void
}

export const Context = createContext<ContextProps>({
  collection: undefined,
  nextElement: undefined,
  previousElement: undefined,
})
Context.displayName = 'CollectionContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const CollectionContext = ({ children }: Props) => {
  const [collection, setCollection] = useState<
    CollectionPageContents_collection | undefined
  >()
  const [nextElement, setNextElement] = useState<ContentPage | undefined>()
  const [previousElement, setPreviousElement] = useState<
    ContentPage | undefined
  >()

  const updateCollectionData = useCallback(
    (data: {
      collection: CollectionPageContents_collection
      previousElement?: ContentPage
      nextElement?: ContentPage
    }) => {
      setCollection(data.collection)
      if (data.previousElement !== undefined) {
        setPreviousElement(data.previousElement)
      }
      if (data.nextElement !== undefined) {
        setNextElement(data.nextElement)
      }
    },
    []
  )

  const value = {
    collection,
    nextElement,
    previousElement,
    updateCollectionData,
  }

  return <Provider value={value}>{children}</Provider>
}

export default CollectionContext
